import { getAllAttachmentsSize } from 'composer-data/attachments/public/operators';
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Small } from 'foundations-components/transitional/components/Small';
import UploadedFile from './UploadedFile';
import UploadingFile from './UploadingFile';
import DeleteAttachmentModal from './DeleteAttachmentModal';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class AttachmentTray extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      deleteAttachmentModalOpen: false,
      uploadedFile: null
    };
  }
  handleFileRemove(uploadedFile) {
    if (uploadedFile.get('hidden')) {
      this.setState({
        deleteAttachmentModalOpen: true,
        uploadedFile
      });
    } else {
      this.props.onRemoveUploadedFile(uploadedFile);
    }
  }
  handleDeleteFileUploadConfirmation() {
    this.props.onDeleteFileUpload({
      fileUpload: this.state.uploadedFile
    });
    this.props.onRemoveUploadedFile(this.state.uploadedFile);
    this.setState({
      deleteAttachmentModalOpen: false,
      uploadedFile: null
    });
  }
  render() {
    const {
      attachments,
      indexedAsyncFileUploads,
      maxFileLimit,
      maxTotalFileSizeLimit,
      onCancelInProgressFileUpload
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [this.state.deleteAttachmentModalOpen && /*#__PURE__*/_jsx(DeleteAttachmentModal, {
        onConfirm: () => this.handleDeleteFileUploadConfirmation(),
        onReject: () => {
          this.setState({
            deleteAttachmentModalOpen: false,
            uploadedFile: null
          });
        }
      }), attachments.size + indexedAsyncFileUploads.size > maxFileLimit && /*#__PURE__*/_jsx(Small, {
        use: "error",
        paddingInlineStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.errors.files-limit-error",
          options: {
            maxFileLimit
          }
        })
      }), attachments && getAllAttachmentsSize(attachments) > maxTotalFileSizeLimit && /*#__PURE__*/_jsx(Small, {
        use: "error",
        paddingInlineStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.errors.total-file-size-error",
          options: {
            maxTotalFileSizeLimit: I18n.formatSize(maxTotalFileSizeLimit)
          }
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        overflowX: "auto",
        paddingInline: "300",
        gap: "200",
        children: [indexedAsyncFileUploads.toList().toArray().map((asyncFileUpload, index) => /*#__PURE__*/_jsx(UploadingFile, {
          asyncFileUpload: asyncFileUpload,
          onRemove: onCancelInProgressFileUpload
        }, `upload-${index}`)), attachments.toArray().map((attachment, index) => /*#__PURE__*/_jsx(UploadedFile, {
          uploadedFile: attachment,
          onRemove: uploadedFile => this.handleFileRemove(uploadedFile)
        }, `attachment-${index}`))]
      })]
    });
  }
}
AttachmentTray.displayName = 'AttachmentTray';
AttachmentTray.propTypes = {
  attachments: ImmutablePropTypes.listOf(PropTypes.object),
  indexedAsyncFileUploads: ImmutablePropTypes.map.isRequired,
  maxFileLimit: PropTypes.number.isRequired,
  maxTotalFileSizeLimit: PropTypes.number,
  onCancelInProgressFileUpload: PropTypes.func.isRequired,
  onRemoveUploadedFile: PropTypes.func.isRequired,
  onDeleteFileUpload: PropTypes.func.isRequired
};